module.exports = __webpack_public_path__ + "static/LogocolorExsis-3767a71e85db81d7d16933184481a4b0.jpg";